import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Modal, { RadioButton, RadioButtonGroup } from '@ublique/components/Modal'
import { isEmpty } from 'lodash'
import './index.scss'

const ValidationModal = ({ open, close, data: { hypotesis, onSave } }) => {
  const { t } = useTranslation(['Wizard', 'Common'])
  const [currentValue, setCurrentValue] = useState(
    isEmpty(hypotesis) ? undefined : hypotesis[0]
  )

  const onSaveModal = () => {
    onSave(currentValue)
    close()
  }

  const onValueChanged = (newValue) => {
    setCurrentValue(newValue)
  }

  return (
    <Modal
      size='sm'
      open={open}
      onRequestClose={close}
      onRequestSubmit={onSaveModal}
      secondaryButtonText={t('Common:Cancel')}
      primaryButtonText={t('Common:Save')}
      primaryButtonDisabled={isEmpty(hypotesis)}
      modalHeading={t('validationHeader')}
      className='validation-scenario-modal'
    >
      {isEmpty(hypotesis) ? (
        <div>{t('noHypotesisFound')}</div>
      ) : (
        <RadioButtonGroup
          name='radio-button-group'
          defaultSelected={currentValue}
          orientation='vertical'
          onChange={onValueChanged}
        >
          {hypotesis.map((op, idx) => {
            return <RadioButton labelText={t(op)} value={op} key={op} id={op} />
          })}
        </RadioButtonGroup>
      )}
    </Modal>
  )
}

export default ValidationModal
